module.exports = __webpack_public_path__ + "img/nuvola_0.5a8f860e.png";